import { SET_SYSTEM_STATE } from "../types";

export const setSystemState = (payload: any) => ({
  type: SET_SYSTEM_STATE,
  payload
});
